import type { ListPageConfig } from '../../core/types';

export const bookingTypeListConfig: ListPageConfig = {
  entityType: 'ahoy_booking_type',
  // User-facing labels say "Booking Link" — clearer than "Booking Type"
  // for what these actually are (configurable shareable links that
  // generate bookings).
  title: 'Booking Link',
  pluralTitle: 'Booking Links',

  columns: [
    { kind: 'object_name', sortable: true, width: 280 },
    { kind: 'property', name: 'ahoy_global_slug', label: 'Slug' },
    { kind: 'association', name: 'ahoy_booking_type_to_owner' },
    { kind: 'property', name: 'ahoy_duration_minutes' },
    { kind: 'property', name: 'ahoy_location_type' },
    { kind: 'property', name: 'ahoy_is_active' },
    { kind: 'property', name: 'ahoy_updated_at' },
  ],

  // Create flow uses the bespoke booking-link config (MeetingTypesPage), not
  // the generic property list.
  createProperties: [],
  createAssociations: [],

  metrics: [],

  defaultFilters: {
    page: 1,
    page_size: 20,
    sort: 'ahoy_updated_at',
    order: 'desc',
  },

  showTimeFilter: false,

  emptyState: {
    heading: 'No booking links yet',
    description:
      'Booking links let contacts schedule time with you directly. Create one to share a link that shows your availability and books meetings automatically.',
  },
};
